import Footer from 'src/components/footer/footer';
import TopNavigation from './topNavigation/TopNavigation';
import HeroSection from './components/HeroSection';
import Header from 'src/components/demo-day/header/Header';
import WhyHowWhatSection from './components/WhyHowWhatSection';
import FeaturesSection from './components/FeaturesSection';
import PartnerInvestors from './components/PartnerInvestors';
import ScoringProcess from './components/ScoringProcess';
import './ScoringEngineLandingPage.scss';
import './components/styles.scss';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useGetIdentity } from 'src/hooks';

const ScoringEngineLandingPage = () => {
  const dispatch = useAppDispatch()
  const [change, setIsChange] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();
  const isAuthorized: boolean = useAppSelector((store) => store.auth.isAuthorized);
  const { getIdentities } = useGetIdentity();
  const { authenticatedId } = getIdentities();

  useEffect(() => {
    window.scrollTo(0, 0)
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsChange(scrollTop > 100);
    };
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    }
  }, [])
  return (
    <>
      <div className="landing-page homeContainer scoring-engine-landing">
        {authenticatedId ? (<Header />) : <TopNavigation change={change} />}
        <main>
          <HeroSection />
          <WhyHowWhatSection />
          <FeaturesSection />
          <PartnerInvestors />
          <ScoringProcess />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default ScoringEngineLandingPage;
